import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import {
  CreateSupplementaryWorksheetsInput,
  GqlError,
  CreateSupplementaryWorksheetsMutation,
  CreateSupplementaryWorksheetsDocument,
} from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

type CreateSupplementaryWorksheetsReturn =
  CreateSupplementaryWorksheetsMutation['createSupplementaryWorksheets']

const createSupplementaryWorksheets = async (
  input: CreateSupplementaryWorksheetsInput,
): Promise<CreateSupplementaryWorksheetsReturn> => {
  try {
    const res = await graphqlRequest(CreateSupplementaryWorksheetsDocument, {
      input,
    })

    return res.createSupplementaryWorksheets
  } catch (error) {
    throw error
  }
}

export const useCreateSupplementaryWorksheets = (
  option?: UseMutationOption<CreateSupplementaryWorksheetsReturn, GqlError>,
) => {
  return useMutation(
    (input: CreateSupplementaryWorksheetsInput) =>
      createSupplementaryWorksheets(input),
    option,
  )
}
